// Prod_US rules, no UI. Same rules as the prototype (personErrors, years, feet).
import { HEIGHT_MAX_IN, HEIGHT_MIN_IN, MAX_AGE, MIN_AGE } from "./prodUsConfig";
import { pt } from "./prodUsStrings";

/* ---------------- phone (US / Canada, +1) ---------------- */

// "(555) 555-0100", "555-555-0100", "+1 555 555 0100" -> "+15555550100"; anything else -> null.
export const toE164 = (input) => {
  let digits = String(input || "").replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") digits = digits.slice(1);
  if (digits.length !== 10) return null;
  // North American numbering: area code and exchange cannot start with 0 or 1.
  if (/^[01]/.test(digits) || /^[01]/.test(digits.slice(3))) return null;
  return `+1${digits}`;
};

// As typed: "5555550100" -> "(555) 555-0100".
export const formatPhone = (input) => {
  const d = String(input || "")
    .replace(/\D/g, "")
    .replace(/^1(?=\d{10}$)/, "")
    .slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// "+15555550100" -> "(•••) •••-0100"
export const maskPhone = (e164) => {
  const d = String(e164 || "").replace(/\D/g, "");
  return `(•••) •••-${d.slice(-4)}`;
};

/* ---------------- About ---------------- */

export const ageFrom = (birthYear, birthMonth, now = new Date()) =>
  now.getFullYear() -
  Number(birthYear) -
  (now.getMonth() + 1 < Number(birthMonth) ? 1 : 0);

// Newest first, starting at this year minus 50.
export const birthYears = (now = new Date()) => {
  const y0 = now.getFullYear();
  const years = [];
  for (let y = y0 - MIN_AGE; y >= y0 - MAX_AGE; y -= 1) years.push(y);
  return years;
};

export const FEET = [4, 5, 6, 7];
export const INCHES = Array.from({ length: 12 }, (_, i) => i);

export const heightCm = (feet, inches) =>
  Math.round((Number(feet) * 12 + Number(inches)) * 2.54);

// d = { fi, li, birthMonth, birthYear, feet, inches, sex }; returns { field: message }.
export const aboutErrors = (d, now = new Date()) => {
  const e = {};
  if (!/^[A-Za-z]$/.test(d.fi || "")) e.fi = pt("err_init");
  if (!/^[A-Za-z]$/.test(d.li || "")) e.li = pt("err_init");
  if (!d.birthMonth || !d.birthYear) e.birth = pt("err_birth");
  else if (ageFrom(d.birthYear, d.birthMonth, now) < MIN_AGE)
    e.birth = pt("err_adult");
  const noFeet = d.feet === "" || d.feet == null;
  const noInches = d.inches === "" || d.inches == null;
  if (noFeet || noInches) e.height = pt("err_height");
  else {
    const total = Number(d.feet) * 12 + Number(d.inches);
    if (total < HEIGHT_MIN_IN || total > HEIGHT_MAX_IN)
      e.height = pt("err_height_range");
  }
  if (!d.sex) e.sex = pt("err_sex");
  return e;
};

/* ---------------- person ---------------- */

// The person's ID ("Client ID"): SL-<initials><age>, then -2, -3 ... if taken.
export const externalIdFor = (fi, li, age, attempt = 1) =>
  `SL-${String(fi).toUpperCase()}${String(li).toUpperCase()}${age}${attempt > 1 ? `-${attempt}` : ""}`;

// The step1 / step2 objects that the existing toPatientPayload (mmtUserList/mmtApi.js) turns
// into the POST /seniors body. Prod_US stores initials only, as first_name / last_name.
export const toPersonSteps = (d, attempt = 1, now = new Date()) => {
  const fi = String(d.fi).toUpperCase();
  const li = String(d.li).toUpperCase();
  const age = ageFrom(d.birthYear, d.birthMonth, now);
  return {
    step1: {
      firstname: fi,
      lastname: li,
      testPersonId: externalIdFor(fi, li, age, attempt),
      gender: d.sex === "F" ? "female" : "male",
      birthYear: Number(d.birthYear),
      birthMonth: Number(d.birthMonth),
    },
    step2: { height: heightCm(d.feet, d.inches) },
  };
};

/* ---------------- credits ---------------- */

export const canStartCheck = (credits, perCheck) => Number(credits) >= perCheck;
